export class QuerySpecificationUtils {
  public static mappingQuery(specification: Specification): string | undefined {
    switch (specification) {
      case "BETWEEN":
        return "_between_";
      case "EQUAL":
        return "::";
      case "GREATER_OR_EQUAL":
        return ">";
      case "IN":
        return "_in_";
      case "IS":
        return "_is_";
      case "LIKE":
        return "~:";
      case "NOT_EQUAL":
        return "!:";
      case "LESS_OR_EQUAL":
        return "<";
      case "START_WITH":
        return "^:";
      default:
        return undefined;
    }
  }

  public static mappingLabel(specification: Specification): string | undefined {
    return "ENUMS." + specification;
  }
}

export type Specification =
  'EQUAL'
  | 'NOT_EQUAL'
  | 'GREATER_OR_EQUAL'
  | 'LESS_OR_EQUAL'
  | 'LIKE'
  | 'IN'
  | 'IS'
  | 'BETWEEN'
  | 'START_WITH'; // 'NULL' | 'NOT_NULL' |
